/* eslint-disable react/require-default-props */
import React, { forwardRef, Ref } from 'react';
import { useFormContext } from 'react-hook-form';

import { scrollTargetStyle } from '../../constants/style';
import CreativesList from '../Creatives/CreativesList';
import FormSection from '../forms/FormSection';

interface AdGroupCreativesSectionProps {
  advertiserId: number;
  lineItemId: number;
}
export default forwardRef((props: AdGroupCreativesSectionProps, ref: Ref<HTMLDivElement>) => {
  const { advertiserId, lineItemId } = props;

  const form = useFormContext();
  const { getValues } = form;
  const adGroupId = getValues('id');

  return (
    <FormSection>
      <div ref={ref} style={scrollTargetStyle} />
      <CreativesList advertiserId={advertiserId} adGroupId={adGroupId} lineItemId={lineItemId} />
    </FormSection>
  );
});
